export default function Avatar({ name }) {
  const initial = name.split(" ")[0][0].toUpperCase();

  return (
    <div
      className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-gray-300 text-white text-sm font-bold"
      title={name}
    >
      {initial}
    </div>
  );
}
